import { render, staticRenderFns } from "./VehicleDetails.vue?vue&type=template&id=0c78fe82&scoped=true&"
import script from "./VehicleDetails.vue?vue&type=script&lang=js&"
export * from "./VehicleDetails.vue?vue&type=script&lang=js&"
import style0 from "./VehicleDetails.vue?vue&type=style&index=0&id=0c78fe82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c78fe82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
